import * as zod from 'zod';

export const RobotOperationMode = zod
  .enum(['live', 'simulated', 'assembly', 'echo', 'gpu', 'unknown'])
  .default('live');

export type RobotOperationMode = zod.infer<typeof RobotOperationMode>;

export const HostType = zod.enum(['vm', 'control-box']);

export type HostType = zod.infer<typeof HostType>;

export const RobotIdentityData = zod.object({
  robotId: zod.string(),
  alias: zod.string(),
  cloudflareTunnelId: zod.string().optional(),
  applicationUrl: zod.string().nullable().default(null),
  robotOperationMode: RobotOperationMode,
  hostType: HostType.optional(),
  hostname: zod.string().optional(),
});

export type RobotIdentityData = zod.infer<typeof RobotIdentityData>;
